import { jsx } from "react/jsx-runtime";
import MenuList from "./MenuList.esm.js";
const DropdownMenu = ({
  isOpen,
  children,
  zIndex,
  left = 0
}) => {
  return /* @__PURE__ */ jsx(MenuList, { sx: {
    display: isOpen ? "block" : "none",
    fontSize: "$fontSizes.body",
    fontWeight: "$fontWeights.body",
    paddingInlineStart: "0",
    "@media $xl": {
      backgroundColor: "$colors.backgroundWhite",
      borderRadius: "$radii.md",
      boxShadow: "$shadows.shadow200",
      minWidth: "calc($spacing.md * 10)",
      overflow: "hidden",
      position: "absolute",
      top: "100%",
      left,
      ...zIndex && {
        zIndex
      }
    },
    "@media $lg_lte": {
      backgroundColor: "$colors.backgroundLight",
      borderTop: "solid 1px $colors.borderLight",
      padding: "$spacing.xs 0",
      position: "relative",
      width: "100%"
    }
  }, children });
};
export {
  DropdownMenu as default
};
